var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85248 8.52643L10.0002 12.0831L14.1478 8.52643C14.4759 8.23143 14.9641 8.27976 15.2373 8.6331C15.358 8.78894 15.4168 8.9781 15.4168 9.16644C15.4168 9.40478 15.3217 9.64145 15.1383 9.80645L10.4954 13.9732C10.459 14.0057 10.4164 14.0223 10.3762 14.0465C10.3437 14.0665 10.3158 14.0907 10.2802 14.1057C10.1913 14.1432 10.0976 14.1657 10.0032 14.1657L10.0001 14.1665L9.99703 14.1657C9.90263 14.1657 9.809 14.1432 9.72001 14.1057C9.68441 14.0907 9.65656 14.0665 9.62406 14.0465C9.58382 14.0223 9.54126 14.0057 9.50489 13.9732L4.862 9.80645C4.5339 9.51228 4.48902 8.98727 4.76295 8.6331C5.03611 8.27976 5.52439 8.23143 5.85248 8.52643Z",
    fill: "#7950F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrow);
export default __webpack_public_path__ + "static/media/purpleArrow.50b9a4e81d701a8c44779d474279016d.svg";
export { ForwardRef as ReactComponent };